import { PAGE_NAME } from '../../../shared/constants';

export const CollectionPageEventTypes = {
    pageView: `${PAGE_NAME}.page_view`,
    header: {
        menu: {
            clicked: `${PAGE_NAME}.header.menu.clicked`,
        },
        actions: {
            shareWithTeam: {
                clicked: `${PAGE_NAME}.header.actions.share_with_team.clicked`,
            },
            socialShare: {
                clicked: `${PAGE_NAME}.header.actions.social_share.clicked`,
            },
            edit: {
                clicked: `${PAGE_NAME}.header.actions.edit.clicked`,
            },
            delete: {
                clicked: `${PAGE_NAME}.header.actions.delete.clicked`,
            },
            copyCollection: {
                clicked: `${PAGE_NAME}.header.actions.copy_collection.clicked`,
                success: `${PAGE_NAME}.header.actions.copy_collection.success`,
                fail: `${PAGE_NAME}.header.actions.copy_collection.fail`,
            },
        },
    },
    itemTabs: {
        tab: {
            clicked: `${PAGE_NAME}.items_view.tab.clicked`,
        },
    },
    sellerCard: {
        clicked: `${PAGE_NAME}.seller_card.clicked`,
        contact: {
            clicked: `${PAGE_NAME}.seller_card.contact.clicked`,
        },
        availableServices: {
            clicked: `${PAGE_NAME}.seller_card.available_services.clicked`,
        },
    },
    inspire: {
        banner: {
            click: `${PAGE_NAME}.inspire.banner.click`,
        },
    },
};
